import { render, staticRenderFns } from "./document-preview.vue?vue&type=template&id=94edefdc&scoped=true"
import script from "./document-preview.vue?vue&type=script&lang=js"
export * from "./document-preview.vue?vue&type=script&lang=js"
import style0 from "./document-preview.vue?vue&type=style&index=0&id=94edefdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94edefdc",
  null
  
)

export default component.exports